document.addEventListener('click', async function (e) {

  const addBtn = e.target.closest('.kb-add-to-cart');
  const buyBtn = e.target.closest('.kb-buy-now');

  if (!addBtn && !buyBtn) return;

  e.preventDefault();

  const btn = addBtn || buyBtn;
  const variantId = btn.dataset.variantId;

  if (!variantId) return;

  btn.disabled = true;

  if (addBtn) {
    btn.innerText = 'Adding...';
  }

  if (buyBtn) {
    btn.innerText = 'Redirecting...';
  }

  try {

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    });

    if (!response.ok) {
      throw new Error();
    }

    if (addBtn) {

      btn.innerText = 'Added ✓';

      setTimeout(() => {
        btn.innerText = 'Add To Cart';
        btn.disabled = false;
      }, 1500);

    } else {

      window.location.href = '/cart?buynow=1';

    }

  } catch (err) {

    btn.disabled = false;

    if (addBtn) {
      btn.innerText = 'Add To Cart';
    } else {
      btn.innerText = 'Buy Now';
    }

    console.error(err);

  }

});